import {FileModel} from '../../../craft/files/file.model'
import {DirectoryPro, GooglePlace, ProPublicLocation} from '../pro-directory/pro.directory.types'

export interface ProMapLocation {
  id: string
  companyName: string
  proSlug: string
  logo?: FileModel
  postalCode: number
  locality: string
  default?: boolean
  geoPoint?: google.maps.LatLngLiteral
  googlePlace?: GooglePlace
}

export function proMapLocationFrom(pro: DirectoryPro, location: ProPublicLocation): ProMapLocation {
  return {
    id: `${pro.slug}-${location.postalCode}`,
    logo: pro.logo,
    companyName: pro.name,
    proSlug: pro.slug,
    postalCode: location.postalCode,
    locality: location.locality,
    geoPoint: location.geoPoint,
    googlePlace: location.googlePlace,
  }
}
